import React, { useState, useEffect } from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Moment from "react-moment";
import relatedPerson from "./relatedperson.json";
import coverage from "./coverage.json";
import appointment from "./appointment.json"
import moment from "moment";

function Dashboard() {
  let AccessToken = localStorage.getItem("AccessToken");
  let NodeServerHost = process.env.REACT_APP_API_URL;
  let CareCode = localStorage.getItem("CareCode");
  let OperatingId = process.env.REACT_APP_OperatingId;
  let orgId = localStorage.getItem("orgId");

  const requestOptions = {
    method: "GET",
    headers: {
      OrganizationId: orgId,
      CareCode: CareCode,
      OperatingId: OperatingId,
      Subject: "_include=ImagingStudy:subject",
      Authorization: "Bearer " + AccessToken,
      "Content-Type": "application/json",
    },
  };

  const [patientData, setPatientData] = useState();

  const [appointmentData, setAppointmentPersonData] = useState();
  const [appointmentIsLoading, setAppointmentIsLoading] = useState(false);

  useEffect(() => {
    setAppointmentPersonData(appointment);
  }, []);

  const [relatedPersonData, setRelatedPersonData] = useState();
  const [relatedPersonIsLoading, setRelatedPersonIsLoading] = useState(false);

  useEffect(() => {
    setRelatedPersonData(relatedPerson);
  }, []);

  const [coverageData, setCoverageData] = useState();
  const [coverageDataIsLoading, setCoverageDataIsLoading] = useState(false);

  useEffect(() => {
    setCoverageData(coverage);
  }, []);

  //console.log(coverageData);

  useEffect(() => {
    (async () => {
      fetch(NodeServerHost + `/Patient`, requestOptions)
        .then((response) => response.json())
        .then((responseData) => {
          setPatientData(responseData);
        })
        .catch();
    })();
  }, []);

  //console.log(patientData);

  //   async function getvals(){
  //     return await fetch(NodeServerHost + `/Patient`, requestOptions)
  //       .then((response) => response.json())
  //       .then((responseData) => {
  //         console.log(responseData)
  //         setPatientData(responseData)
  //       })
  //       .catch();
  //   }

  //   getvals().then(response => console.log(response))

  //console.log(patientData)
  

  //console.log(otherMrn[0])
  //   const email = patientData?.telecom.map((telecom) => {
  //     console.log(telecom)
  //     // if (telecom.use === "home") {
  //     //     return telecom.value
  //     // }
  //   })

  //console.log(mrn)

  const [studyList, setStudyList] = useState([]);

  const [isLoading, setIsLoading] = useState(false);

  const studyHeaders = {
    method: "GET",
    headers: {
      OrganizationId: orgId,
      CareCode: CareCode,
      OperatingId: OperatingId,
      Subject: "",
      Authorization: "Bearer " + AccessToken,
      "Content-Type": "application/json",
    },
  };

  useEffect(() => {
    setIsLoading(true);
    fetch(NodeServerHost + `/Study`, studyHeaders)
      .then((response) => response.json())
      .then((responseData) => {
        //console.log(responseData);
        setIsLoading(false);
        setStudyList(responseData);
      })
      .catch();
  }, []);

  //console.log(studyList);
  
  const [reportList, setReportList] = useState([]);

  const [isReportLoading, setIsReportLoading] = useState(false);

  useEffect(() => {
    setIsReportLoading(true);
    fetch(NodeServerHost + `/Report`, studyHeaders)
      .then((response) => response.json())
      .then((responseData) => {
        //console.log(responseData);
        setIsReportLoading(false);
        setReportList(responseData);
      })
      .catch();
  }, []);

  //console.log(reportList);

  if(patientData !== undefined){
    const mrnId = patientData?.identifier?.map((id) => {
      if (id.type.coding[0].code === "MR") {
        return id.value;
      }
      //return id;
    });
  
    const mrn = mrnId?.filter(element => element !== undefined);
  
    const phonenoTelecom = patientData?.telecom?.map((telecom) => {
      if (telecom.system === "phone") {
        return telecom.value;
      }
      //return telecom;
    });
  
    const phoneno = phonenoTelecom?.filter(element => element !== undefined);
  
    const emailTelecom = patientData?.telecom?.map((email) => {
      if (email.system === "email") {
        return email.value;
      }
      //return email;
    });
  
    const email = emailTelecom?.filter(element => element !== undefined);
  
    const otherMrnId = patientData?.identifier?.map((id) => {
      if (id.type.coding[0].code === "OMR") {
        return id.value;
      }
      //return id;
    });
  
    const otherMrn = otherMrnId?.filter(element => element !== undefined)

    console.log(patientData)
    const patientPhoto = 'data:' + patientData.photo[0].contentType + ';base64,' + patientData.photo[0].data;

    return (
      
      <div className="ps-3 mt-4 pe-3">
        <div className="row">
          <div className="form-group read-only-fields col-md-4 mb-3">
            <img src={patientPhoto} alt={patientData?.name[0].given[0]} className="empty-profile-details patientPhoto"></img>
            <div className="PatientDetails form-group no-height read-only-fields col-md-12">
              <h4 className="mb-1 mt-2">
                {patientData?.name[0].given[0]} {patientData?.name[0].family}
              </h4>
              <span className="ps-0">
                {patientData?.gender === ""
                  ? ""
                  : patientData?.gender === "male"
                  ? "( M )"
                  : patientData?.gender === "female"
                  ? "( F )"
                  : patientData?.gender === "other"
                  ? "( O )"
                  : ""}{" "}
                <Moment format="MM/DD/YYYY">{patientData?.birthDate}</Moment>
              </span>
            </div>
          </div>
          <div className="form-group read-only-fields col-md-8">
            <ul className="stripInfo float-end">
              <li>
                <span>{mrn[0]}</span>
                MRN
              </li>
              <li>
                <span>{phoneno[0]}</span>
                Phone Number
              </li>
              <li>
                <span>{email[0]}</span>
                Email
              </li>
            </ul>
          </div>
          <div className="col-md-12">
            <Tabs defaultActiveKey="myinfo" id="userdashboard" className="mb-3">
              <Tab eventKey="myinfo" title="Personal Details">
                <div className="row">
                  <div className="col-md-5">
                    <h5>Patient Information</h5>
                    <div className="card">
                      <div className="card-body">
                        <div className="read-only-fields col-md-12 mb-3">
                          <p>
                            <strong>Other MRN</strong>
                            <span>{otherMrn[0]}</span>
                          </p>
                          <p>
                            <strong>Preffered Languages</strong>
                            <span>-</span>
                          </p>
                          <p>
                            <strong>Managing Organization</strong>
                            <span>{patientData?.managingOrganization?.display}</span>
                          </p>
                          <p>
                            <strong>Address</strong>
                            <span>{patientData?.address?.city} {patientData?.address?.district} {patientData?.address?.state} {patientData?.address?.postalCode}</span>
                          </p>
                        </div>
                      </div>
                    </div>
  
                    <h5 className="mt-4">Contact Persons</h5>
                    <div className="card">
                      <div className="card-body">
                        No contact found
                      </div>
                    </div>
                  </div>
                  
                  <div className="col-md-7">
                    <h5>Related Persons</h5>
                    <div className="card">
                      <div className="card-body">
                        <table className="table table-sm mb-0">
                          <thead className="thead-light">
                              <tr className="table-active">
                                <th scope="col" width="30%">Person Name</th>
                                <th scope="col" width="10%">Gender</th>
                                <th scope="col" width="14%">Relationship</th>
                                <th scope="col" width="23%">Phone No</th>
                                <th scope="col" width="23%">Email</th>
                              </tr>
                          </thead>
                          {relatedPersonIsLoading === true && (
                            <tbody>
                              <tr>
                                <td colSpan="5">
                                  <div className="spinner-border" role="status"></div>
                                </td>
                              </tr>
                            </tbody>
                          )}
                          {relatedPersonIsLoading === false && (
                            <tbody>
                              {relatedPersonData === "No records found"
                              ? <tr>
                                  <td colSpan="5">
                                    {relatedPersonData}
                                  </td>
                                </tr>
                              : relatedPersonData.map((relatedPerson) => {
                                //console.log(relatedPerson.resource);
                                const relationName = relatedPerson.resource.relationship.map((relationname) => {
                                  return relationname.coding[0].display
                                })

                                const relatedpersonphone = relatedPerson.resource.telecom?.map((telecom) => {
                                  if (telecom.system === "phone") {
                                    return telecom.value;
                                  }
                                  //return telecom;
                                }); 
                                
                                const relatedpersonemail = relatedPerson.resource.telecom?.map((telecom) => {
                                  if (telecom.system === "email") {
                                    return telecom.value;
                                  }
                                  //return telecom;
                                }); 
                                //console.log(relatedpersonemail);

                                
                                return (
                                  <tr>
                                    <td>
                                      {relatedPerson.resource.name[0].given[0]} {relatedPerson.resource.name[0].given[1]} {relatedPerson.resource.name[0].family}
                                    </td>
                                    <td>{relatedPerson.resource.gender}</td>
                                    <td>{relationName[0]}</td>
                                    <td>{relatedpersonphone}</td>
                                    <td>{relatedpersonemail}</td>
                                  </tr>
                                )
                              })}
                            </tbody>
                          )}
                        </table>
                      </div>
                    </div>
  
                    <h5 className="mt-4">Coverages</h5>
                    <div className="card">
                      <div className="card-body">
                        <table className="table table-sm mb-0">
                          <thead className="thead-light">
                              <tr className="table-active">
                                <th scope="col" width="30%">Policy Holder</th>
                                <th scope="col" width="10%">Status</th>
                                <th scope="col" width="20%">Insurance Type</th>
                                <th scope="col" width="20%">Period Start</th>
                                <th scope="col" width="20%">Period End</th>
                              </tr>
                          </thead>
                          {coverageDataIsLoading === true && (
                            <tbody>
                              <tr>
                                <td colSpan="5">
                                  <div className="spinner-border" role="status"></div>
                                </td>
                              </tr>
                            </tbody>
                          )}
                          {coverageDataIsLoading === false && (
                            <tbody>
                              {coverageData === "No records found"
                              ? <tr>
                                  <td colSpan="5">
                                    {coverageData}
                                  </td>
                                </tr>
                              : coverageData.map((coverage) => {
                                //console.log(coverage.resource);
                                return (
                                  <tr>
                                    <td>
                                      {coverage.resource.policyHolder.display}
                                    </td>
                                    <td>{coverage.resource.status}</td>
                                    <td>{coverage.resource.type?.coding[0].display}</td>
                                    <td>
                                    {coverage.resource.period !== undefined &&
                                      <Moment format="MM/DD/YYYY hh:mm A">{coverage.resource.period?.start}</Moment>
                                    }
                                    </td>
                                    <td>
                                      {coverage.resource.period !== undefined && 
                                        <Moment format="MM/DD/YYYY hh:mm A">{coverage.resource.period?.end}</Moment>  
                                      }
                                    </td>
                                  </tr>
                                )
                              })}
                            </tbody>
                          )}
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab>
              {/* <Tab eventKey="journey" title="Journey">
                Tab2
              </Tab> */}
              <Tab eventKey="communications" title="Communications">
                No communications found
              </Tab>
              <Tab eventKey="imagingstudies" title="Imaging Studies" className="pt-3">
                {isLoading === true && (
                  <div>
                    <div className="spinner-border" role="status"></div>Loading...
                  </div>
                )}
                {isLoading === false && (
                  <div>
                    {studyList === "No records found"
                      ? studyList
                      : studyList.map((imagingstudy) => {
                          //console.log(imagingstudy.participant)
                          //const practitioner = imagingstudy.participant.map()
                          const lastUpdatedTime = imagingstudy.meta.lastUpdated.split(".");
                          return (
                            <div className="col-md-12">
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="card">
                                    <div className="card-body">
                                      <h4>{imagingstudy.description}</h4>
                                      <p className="card-text mb-2">
                                        <span className="me-3">
                                          <span className="fw-bold me-1">
                                            Modality: 
                                          </span>
                                          {imagingstudy.modality.map((modality, i) => [
                                              i > 0 && ", ",
                                              <span>{modality.display}</span>
                                          ])}
                                        </span>
                                        <span className="me-3">
                                          <span className="fw-bold me-1">
                                            Acc#: 
                                          </span>
                                          {imagingstudy.identifier.map((id, i) => 
                                              id.type !== undefined &&
                                              id.type.text === "Accession ID" &&
                                              <span>{id.value}</span>
                                          )}
                                        </span>
                                      </p>
                                      <p className="card-text mb-2">
                                        <span className="me-3">
                                          <span className="fw-bold me-1">
                                            Referring Physician: 
                                          </span>
                                          {imagingstudy.referrer === undefined ? "-" : imagingstudy.referrer.display}
                                        </span>
                                      </p>
                                      <p className="card-text mb-2">
                                        <span className="me-3">
                                          <span className="fw-bold me-1">
                                            Study Date/Time: 
                                          </span>
                                          <Moment format="MM/DD/YYYY">
                                          {imagingstudy.started}
                                          </Moment>
                                          &nbsp;
                                          <Moment
                                          className="text-secondary"
                                          parse="YYYY-MM-DD HH:mm"
                                          format="hh:mm a"
                                          >
                                          {imagingstudy.started}
                                          </Moment>
                                        </span>
                                        <span className="me-3">
                                          <span className="fw-bold me-1">
                                            Upload Date/Time: 
                                          </span>
                                          <Moment format="MM/DD/YYYY">
                                          {imagingstudy.meta.lastUpdated}
                                          </Moment>
                                          &nbsp;
                                          <Moment
                                          className="text-secondary"
                                          parse="YYYY-MM-DD HH:mm"
                                          format="hh:mm a"
                                          >
                                          {lastUpdatedTime[0]}
                                          </Moment>
                                        </span>
                                      </p>
                                      <a className="btn btn-primary btn-sm mt-2" href="/"><i className="fa fa-eye"></i> View</a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                  </div>
                )}
              </Tab>
              <Tab eventKey="appointments" title="Appointments">
                {appointmentIsLoading === true && (
                  <div>
                    <div className="spinner-border" role="status"></div>Loading...
                  </div>
                )}
                {appointmentIsLoading === false && (
                  <div className="col-md-12">
                    <div className="row">
                    <h4 className="mb-3">Appointments</h4>
                      {appointmentData === "No records found"
                        ? appointmentData
                        : appointmentData.map((appointment) => {
                          //console.log(appointment)
                          let serviceName = '';
                          let practitionerName = [];
                          let deviceName = [];
                          appointment.participant.map((participant) => {
                            if(participant.actor.reference.split('/')[0] === 'HealthcareService'){
                              serviceName = participant.actor.display;
                            } else if(participant.actor.reference.split('/')[0] === 'Practitioner'){
                              practitionerName.push(participant.actor.display);
                            } else if(participant.actor.reference.split('/')[0] === 'Device'){
                              deviceName.push(participant.actor.display);
                            }
                          })
                          //console.log(practitionerName.join(', '))
                          //{moment.utc(comment.created_at).local().format('h:mm a')}
                          //console.log(appointment.start + " = " +moment.utc(appointment.start).local().format('hh:mm a'))
                          console.log(appointment.start + " = " + moment(appointment.start).format('YYYY-MM-DDTHH:mm'))
                          console.log(moment.utc("2022-07-25T14:30").utcOffset("-04:00").format('h:mm a'))
                          return (
                            <div className="col-md-6">
                              <div className="card">
                                <div className="card-body">
                                  <h5 class="card-title mb-3">{serviceName}</h5>
                                  <p className="card-text mb-2">
                                    <span className="me-3">
                                      <span className="fw-bold me-1">
                                        Practitioner: 
                                      </span>
                                      {practitionerName.join(', ')}
                                    </span>
                                  </p>
                                  <p className="card-text mb-2">
                                    <span className="me-3">
                                      <span className="fw-bold me-1">
                                        Device: 
                                      </span>
                                      {deviceName.join(', ')}
                                    </span>
                                  </p>
                                  <p className="card-text mb-2">
                                    <span className="me-3">
                                      <span className="fw-bold me-1">
                                        Description: 
                                      </span>
                                      {appointment.description}
                                    </span>
                                  </p>
                                  <p className="card-text mb-2">
                                    <span className="me-3">
                                      <span className="fw-bold me-1">
                                        Patient Instruction: 
                                      </span>
                                      {appointment.patientInstruction}
                                    </span>
                                  </p>
                                  <p className="card-text mb-2">
                                    <span className="me-3">
                                      <span className="fw-bold me-1">
                                        Start Date/Time: 
                                      </span>
                                      <Moment className="text-secondary" parse="YYYY-MM-DD HH:mm" format="MM/DD/YYYY hh:mm a">
                                        {appointment.start}
                                      </Moment>
                                    </span>
                                    <span className="me-3">
                                      <span className="fw-bold me-1">
                                        End Date/Time: 
                                      </span>
                                      <Moment className="text-secondary" parse="YYYY-MM-DD HH:mm" format="MM/DD/YYYY hh:mm a">
                                        {appointment.end}
                                      </Moment>
                                    </span>
                                  </p>
                                </div>
                              </div>
                            </div>
                          )
                        })
                      }
                    </div>
                  </div>
                )}
              </Tab>
              <Tab eventKey="reports" title="Reports" className="pt-3">
              {isReportLoading === true && (
                <div>
                  <div className="spinner-border" role="status"></div>Loading...
                </div>
              )}
              {isReportLoading === false && (
                  <div>
                    {reportList === "No records found"
                      ? reportList
                      : reportList.map((diagnosticreport) => {
                          //console.log(diagnosticreport)
                          const lastUpdatedTime = diagnosticreport.meta.lastUpdated.split(".");
                          return (
                            <div className="col-md-12">
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="card">
                                    <div className="card-body">
                                      <h4>{diagnosticreport.code.coding[0].display}</h4>
                                      <p className="card-text mb-2">
                                        <span className="me-3">
                                          <span className="fw-bold me-1">
                                            Referring Physician: 
                                          </span>
                                          static physician
                                        </span>
                                      </p>
                                      <p className="card-text mb-2">
                                        <span className="fw-bold me-1">
                                          Conclusion: 
                                        </span>
                                        {diagnosticreport.conclusion}
                                      </p>
                                      <p className="card-text mb-2">
                                        <span className="fw-bold me-1">
                                          Category: 
                                        </span>
                                        {diagnosticreport.category.map((category, i) => [
                                            i > 0 && ", ",
                                            <span>{category.coding[0].code}</span>
                                        ])}
                                      </p>
                                      <p className="card-text mb-2">
                                        <span className="me-3">
                                          <span className="fw-bold me-1">
                                            Effective Date/Time: 
                                          </span>
                                          
                                          {diagnosticreport.effectiveDateTime == undefined
                                            ? "-"
                                            : <span>
                                              <Moment format="MM/DD/YYYY">
                                                {diagnosticreport.effectiveDateTime}
                                              </Moment>
                                              &nbsp;
                                              <Moment className="text-secondary" parse="YYYY-MM-DD HH:mm" format="hh:mm a">
                                                {diagnosticreport.effectiveDateTime}
                                              </Moment>
                                            </span>
                                          }
                                        </span>
                                        <span className="me-3">
                                          <span className="fw-bold me-1">
                                            Upload Date/Time: 
                                          </span>
                                          <Moment format="MM/DD/YYYY">
                                          {diagnosticreport.meta.lastUpdated}
                                          </Moment>
                                          &nbsp;
                                          <Moment
                                          className="text-secondary"
                                          parse="YYYY-MM-DD HH:mm"
                                          format="hh:mm a"
                                          >
                                          {lastUpdatedTime[0]}
                                          </Moment>
                                        </span>
                                      </p>
                                      <a className="btn btn-primary btn-sm mt-2" href="/"><i className="fa fa-eye"></i> Report</a>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )
                        }
                    )}
                  </div>
                )}
              </Tab>
              <Tab eventKey="documents" title="Documents">
                Tab7
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>
    );
  }
  
}

export default Dashboard;
